import { ReactComponent as GoLogo1Svg } from 'assets/svgs/gocaby_black.svg';
import { ReactComponent as GoLogo2Svg } from 'assets/svgs/gocaby_white.svg';
import { ReactComponent as GoLogo3Svg } from 'assets/svgs/GOCABY LOGO 2.svg';

/**
 *
 * @param {GoLogoSvgProps} props
 * @returns
 */
function GoLogoSvg(props) {
  const { variant, ...restProps } = props;
  const GoSvg = [GoLogo1Svg, GoLogo2Svg, GoLogo3Svg][variant];
  return <GoSvg {...restProps} />;
}

GoLogoSvg.defaultProps = {
  variant: 1,
};

export default GoLogoSvg;

/**
 * @typedef {{
 * variant: 1 | 2
 * } & import("react").ComponentPropsWithoutRef<typeof GoSvg>} GoLogoSvgProps
 */
